import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useFamilyAllowanceChartsDataContext } from './hooks/useFamilyAllowanceChartsDataContext';
import { getMonthLabel } from '../../../Common/Util/getMonthLabel';

export const TransferValuePerMonth = () => {
    const { chartData } = useFamilyAllowanceChartsDataContext();

    const rawData = chartData.values.monthly;

    const series = [
        {
            name: 'Valor Repassado',
            data: rawData.map(item => Number(item.value))
        }
    ];

    const isYearComparison =
        rawData.length > 0 &&
        rawData.every(item => item.mes === rawData[0].mes);

    const formattedSubtitles = isYearComparison
        ? rawData.map(item => `${getMonthLabel(item.mes)}/${item.ano}`)
        : rawData.map(item => getMonthLabel(item.mes));

    return (
        <SimpleBars
            title="Valor Repassado - Mensal"
            horizontal={false}
            subtitles={formattedSubtitles}
            series={series}
        />
    );
};
